import { FigureVarData, isFigureVarData } from "./FigureVarData";

export interface FigureRegressionLineData {
  id: string;
  lineType: string;
  properties: FigureVarData[];
}

/**
 * Type guard to check if an object is a FigureRegressionLineData
 *
 * @param obj - The object to check
 * @returns - true if the object is a FigureRegressionLineData
 */
export const isFigureRegressionLineData = (obj: unknown): obj is FigureRegressionLineData => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureRegressionLineData;
  if (typeof chkObj.id !== "string") {
    return false;
  }
  if (typeof chkObj.lineType !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.properties)) {
    return false;
  }
  if (chkObj.properties.some((prop) => !isFigureVarData(prop))) {
    return false;
  }
  return true;
};
